module.exports = __webpack_public_path__ + "img/screenshot.f41ad3bf.png";